// Iniciais sobre um fundo pastel estável por nome (a mesma pessoa sempre cai na mesma cor).
// Se vier `src` (avatarUrl do detalhe), mostra a foto.
const PALETTE = [
  'bg-violet-100 text-violet-700',
  'bg-sky-100 text-sky-700',
  'bg-emerald-100 text-emerald-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
  'bg-indigo-100 text-indigo-700',
  'bg-teal-100 text-teal-700',
  'bg-fuchsia-100 text-fuchsia-700',
];

const SIZES = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-14 w-14 text-lg',
};

export const getInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const colorFor = (name) => {
  const s = String(name || '');
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
};

export const Avatar = ({ name, src, size = 'md' }) => {
  if (src) {
    return <img src={src} alt="" className={`${SIZES[size]} flex-shrink-0 rounded-full object-cover ring-2 ring-white`} />;
  }
  return (
    <div className={`${SIZES[size]} ${colorFor(name)} flex flex-shrink-0 items-center justify-center rounded-full font-semibold ring-2 ring-white`}>
      {getInitials(name)}
    </div>
  );
};
